import { getSenderId, getSenderType, getSenderKey
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { UTK } from 'conversations-message-history/common-message-format/constants/senderIdKeys';
import SlottedMessage from '../slotted-message/SlottedMessage';
import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import FullSenderName from '../senders/components/FullSenderName';
import { jsx as _jsx } from "react/jsx-runtime";
const TypingIndicator = ({
  message,
  onClickAvatar,
  positionDescriptors,
  senderName,
  senders,
  vid,
  ungatedForThreadMessagesUIImprovements
}) => {
  const senderId = getSenderKey(message) === UTK ? vid : getSenderId(message);
  const senderType = getSenderType(message);
  const isFromVisitor = getSenderType(message) === VISITOR_SENDER;
  const asyncSender = findSender(senderId, senderType, senders);
  const sender = getData(asyncSender);
  const isLoading = isSenderLoading(asyncSender);
  const use = isFromVisitor ? VISITOR : AGENT;
  const title = {
    Component: FullSenderName,
    componentProps: {
      sender,
      senderName,
      isLoading
    }
  };
  const avatar = {
    componentProps: {
      onClick: onClickAvatar,
      sender,
      use,
      isLoading,
      size: 'sm'
    },
    isLoading
  };
  const body = {
    renderCustom: () => /*#__PURE__*/_jsx(LoadingDots, {
      grow: false
    })
  };
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        positionDescriptors,
        use,
        ungatedForThreadMessagesUIImprovements
      }
    },
    avatar: avatar,
    title: title,
    body: body
  });
};
TypingIndicator.displayName = 'TypingIndicator';
export default TypingIndicator;